import { tv } from 'tailwind-variants';

export const tabStyles = tv({
  slots: {
    root: 'flex flex-col gap-2',
    list: 'inline-flex w-fit items-center justify-center rounded-lg p-1',
    trigger:
      'inline-flex flex-1 items-center justify-center whitespace-nowrap cursor-pointer transition-all duration-300 focus-visible:ring-[3px] focus-visible:outline-1 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring [&_svg]:pointer-events-none [&_svg]:shrink-0',
    content: 'flex-1 outline-none',
    indicator:
      'bg-primary pointer-events-none absolute rounded-full opacity-0 transition-all duration-300 ease-out',
  },
  variants: {
    variant: {
      default: {
        list: 'gap-x-2',
        trigger:
          'flex flex-col bg-background text-primary/70 rounded-lg shadow-sm gap-y-0.5 hover:text-primary hover:scale-105 data-[state=active]:text-primary-dark-one data-[state=active]:scale-115',
      },
      horizontal: {
        list: 'bg-card h-fit relative border border-border p-2 gap-x-4',
        trigger:
          'flex w-full opacity-60 text-primary hover:opacity-100 data-[state=active]:opacity-100',
        indicator: 'h-1 top-full',
      },
      vertical: {
        list: 'bg-zinc-100 h-fit relative border border-zinc-200 rounded-xl grid auto-rows-[minmax(40px,auto)] p-3 gap-y-4',
        trigger:
          'flex w-full opacity-70 text-primary hover:text-primary-dark-one hover:opacity-100 data-[state=active]:text-primary-dark-one data-[state=active]:opacity-100',
        indicator: 'w-1 left-full ml-1',
      },
    },
    size: {
      default: {
        trigger: 'h-[calc(100%-1px)] text-sm',
      },
      sm: {
        trigger: 'h-[calc(100%-1px)] text-xs',
      },
      lg: {
        trigger: 'h-[calc(100%-1px)] text-base',
      },
      xl: {
        trigger: 'h-[calc(100%-1px)] text-lg',
      },
      icon: {
        trigger: 'size-14',
      },
      'icon-sm': {
        trigger: 'size-10',
      },
      'icon-xs': {
        trigger: 'size-8',
      },
    },
    disabled: {
      true: {
        trigger: 'pointer-events-none cursor-not-allowed opacity-50',
      },
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
  },
});

type TabVariant = 'horizontal' | 'vertical' | 'default';
type IndicatorStyleFn = (rects: {
  listRect: DOMRect;
  triggerRect: DOMRect;
}) => Record<string, string>;

export const indicatorStylesByVariant: Record<TabVariant, IndicatorStyleFn> = {
  horizontal: ({ listRect, triggerRect }) => ({
    left: `${triggerRect.left - listRect.left}px`,
    width: `${triggerRect.width}px`,
  }),
  vertical: ({ listRect, triggerRect }) => ({
    top: `${triggerRect.top - listRect.top}px`,
    height: `${triggerRect.height}px`,
  }),
  default: () => ({}),
};
